import { render } from "./App.vue?vue&type=template&id=27ec2453"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=27ec2453&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__